import React, { useState } from "react";
import AdminInputModel from "../../../../../components/admin-input-modal/AdminInputModal";
import { rewardTypeFormValidation } from "../../../../../FormValidations/super-admin/RewardTypeFormValidation";
import { apiClient } from "../../../../../utils/apiClient";
import { useDispatch } from "react-redux";
import { setSnackbarDetails } from "../../../../../redux/AuthReducer/AuthSlice";

type rewardTypeDetailsState = {
  name: string;
};

type createRewardTypeprops = {
  isOpen: boolean;
  refreshList: (signal: AbortSignal) => Promise<void>;
  onClose: () => void;
};

const CreateRewardType: React.FC<createRewardTypeprops> = ({
  isOpen,
  refreshList,
  onClose,
}) => {
  const dispatcher = useDispatch();
  const [rewardType, setRewardType] = useState<rewardTypeDetailsState>({
    name: "",
  });
  //using the following state to store the error messages
  const [errors, setErrors] = useState({});

  //using the following state to show the btnLoader when user create the data
  const [btnLoading, setBtnLoading] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRewardType({
      ...rewardType,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };
  const handleCreate = async () => {
    let { status, errors } = rewardTypeFormValidation(rewardType);
    setErrors(errors);
    if (!status) {
      setBtnLoading(true);
      try {
        let controller = new AbortController();
        await apiClient?.post<any>(`/reward-type/create`, rewardType, {
          signal: controller?.signal,
        });
        await refreshList(controller?.signal);
        onClose();
        dispatcher(
          setSnackbarDetails({
            type: "success",
            message: "Reward Type Created Succesfully!",
          }),
        );
      } catch (error: any) {
        dispatcher(
          setSnackbarDetails({
            type: "error",
            message:
              error?.response?.data?.data?.message ??
              "error in creating the Reward Type!",
          }),
        );
      } finally {
        setBtnLoading(false);
      }
    }
  };

  return (
    <div>
      <AdminInputModel
        title="Create Reward Type"
        isOpen={isOpen}
        values={rewardType}
        fields={[
          {
            label: "Reward Name",
            placeholder: "Enter Reward Name",
            name: "name",
          },
        ]}
        btnLoading={btnLoading}
        errors={errors}
        onChange={handleChange}
        onSubmit={handleCreate}
        onClose={onClose}
      />
    </div>
  );
};

export default CreateRewardType;
